// InstallHint.tsx — Android/Chrome: real "Installieren" button via beforeinstallprompt.
// iOS: no such event exists, so show the manual "Teilen -> Zum Home-Bildschirm" hint
// whenever the app isn't already running standalone (D-008).
import { isIos, isStandalone, useInstallPrompt } from '../lib/install.js';

export function InstallHint() {
  const { canInstall, promptInstall } = useInstallPrompt();
  const showIosHint = isIos() && !isStandalone();

  if (!canInstall && !showIosHint) return null;

  return (
    <div class="card">
      <h3>App installieren</h3>
      {canInstall ? (
        <button type="button" class="btn btn-primary btn-block" onClick={() => void promptInstall()}>
          Installieren
        </button>
      ) : null}
      {showIosHint ? (
        <p class="field-hint">
          Auf dem iPhone/iPad: Teilen-Symbol antippen → „Zum Home-Bildschirm", um das
          ETF Cockpit als App zu installieren (offlinefähig).
        </p>
      ) : null}
    </div>
  );
}
